import React, { useState, useEffect, useRef } from "react";
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, Row, ModalHeader } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
import PageGrid from "../../components/GridLayout/PageGrid";

const Reports = () => {
  const itemsPerPage = 5;
  const [activeTab, setActiveTab] = useState("1");
  const navigate = useNavigate();
  const toggle = (tab) => { if (activeTab !== tab) setActiveTab(tab); };
  const selectedMachineId = localStorage.getItem("selectedMachineId");
  const [machines, setMachines] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedMachine, setSelectedMachine] = useState(selectedMachineId);
  const [date, setDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedChildPart, setSelectedChildPart] = useState("all");
  const [mouldingData, setMouldingData] = useState([]);
  const [reportData, setReportData] = useState({ dates:[], rows:[] });
  const [changeOverConsoData, setChangeOverConsoData] = useState([]);
  const [productionData, setProductionData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [ppmData, setPpmData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [scrapData, setScrapData] = useState([]);
  const [days, setDays] = useState([]);

  document.title = "Reports | OptiMize";

  const ReportsContent = (
    <Card className="h-100 mb-0">
      <CardHeader>
        <Nav tabs>
          {[["1","Moulding"],["2","Change Over"],["3","Production"],["4","PPM"],["5","Scrap"]].map(([id,label])=>(
            <NavItem key={id}><NavLink className={classnames({active:activeTab===id})} onClick={()=>toggle(id)} style={{cursor:"pointer"}}>{label}</NavLink></NavItem>
          ))}
        </Nav>
      </CardHeader>
      <CardBody>
        <Row className="mb-3 align-items-end">
          <Col md={3}>
            <label className="form-label">Machine</label>
            <select className="form-control" value={selectedMachine||""} onChange={e=>{setSelectedMachine(e.target.value);localStorage.setItem("selectedMachineId",e.target.value);}}>
              <option value="">Select Machine</option>
              {machines?.map((m,i)=><option key={i} value={m.id}>{m.name}</option>)}
            </select>
          </Col>
          <Col md={2}><label className="form-label">From</label><input type="date" className="form-control" value={fromDate} onChange={e=>setFromDate(e.target.value)}/></Col>
          <Col md={2}><label className="form-label">To</label><input type="date" className="form-control" value={toDate} onChange={e=>setToDate(e.target.value)}/></Col>
          <Col md={2}><label className="form-label">&nbsp;</label>
            <button className="btn btn-primary w-100" disabled={isLoading}>
              {isLoading?<span className="spinner-border spinner-border-sm me-1"/>:null}Submit
            </button>
          </Col>
        </Row>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            {mouldingData.length===0 ? <p className="text-muted text-center py-3">No moulding data. Select machine and date range then click Submit.</p>
              : <p>Moulding data loaded ({mouldingData.length} rows)</p>}
          </TabPane>
          <TabPane tabId="2"><p className="text-muted text-center py-3">Select filters and submit to load change-over data.</p></TabPane>
          <TabPane tabId="3"><p className="text-muted text-center py-3">Select filters and submit to load production data.</p></TabPane>
          <TabPane tabId="4"><p className="text-muted text-center py-3">Select filters and submit to load PPM data.</p></TabPane>
          <TabPane tabId="5"><p className="text-muted text-center py-3">Select filters and submit to load scrap data.</p></TabPane>
        </TabContent>
      </CardBody>
    </Card>
  );

  const widgets = [
    { id:"reports", label:"Production Reports", icon:"mdi mdi-file-chart-outline", defaultW:12, defaultH:10, minH:6, content: ReportsContent },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Reports" />
          <PageGrid pageKey="reports" widgets={widgets} />
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Reports;
